<div *ngIf="!isSdfCardFlow">
  <h3 class="mg-step-header summary-header">
    <ng-container>
      {{ labels.stellar.summary.header }}
    </ng-container>
  </h3>

  <div class="currency-deposit">
    <div class="deposit-amount-currency">
      <h2 class="currency-label" *ngIf="flow === 'deposit'">
        {{ labels.stellar.summary.depositAmount }}
      </h2>
      <h2 class="currency-label" *ngIf="flow === 'withdraw'">
        {{ labels.stellar.summary.withdrawalAmount }}
      </h2>
      <h1 class="currency-value">{{ getTotalUSDC() }} USDC</h1>
    </div>
    <div class="glob-flag flag"></div>
  </div>

  <app-summary-section
    *ngFor="let section of sections"
    [items]="section.items"
    [title]="section.title"
    [footer]="section.footer"
  >
  </app-summary-section>

  <div class="totals-container">
    <div class="total-row mat-body">
      <h4 class="bold-text">
        {{ getTotalCostLabel() }}
      </h4>
      <p class="bold-text">{{ getTotalCost() }} {{ getTotalCostCurrency() }}</p>
    </div>
  </div>

  <app-indicative-rate-note></app-indicative-rate-note>

  <div *ngIf="flow === 'deposit' && locationFinderService.selectedBranch">
    <app-location-search-detail
      [flow]="flow"
      [showChangeLocator]="false"
      [labels]="locationLabels"
      [pinSelectedLocation]="
        locationFinderService.selectedBranch ? true : false
      "
    ></app-location-search-detail>
  </div>

  <app-terms-and-conditions
    [flow]="flow"
    [labels]="labels"
    [locale]="locale"
  ></app-terms-and-conditions>

  <div class="mg-step-actions-row">
    <button color="primary" mat-raised-button (click)="next.emit(config)">
      {{ labels.stellar.submit }}
    </button>
  </div>
</div>

<div *ngIf="isSdfCardFlow" class="sdf-card">
  <div class="header-container">
    <h3 class="card-header">{{ sdfCardLabels.reviewPage.reviewHeader }}</h3>
  </div>
  <div class="summary-wrapper">
    <app-card-summary-section
      class="summary-section"
      *ngFor="let section of sections"
      [items]="section.items"
      [title]="section.title"
      [footer]="section.footer"
    >
    </app-card-summary-section>
  </div>
  <div class="terms-and-condition-contianer">
    <app-terms-and-conditions
      [flow]="flow"
      [labels]="labels"
      [locale]="locale"
    ></app-terms-and-conditions>
  </div>

  <div class="submitButton-container">
    <!-- <button color="primary" mat-raised-button (click)="next.emit(config)">
      {{ labels.stellar.submit }}
    </button> -->
    <section class="form-button-container">
      <div class="button-container">
        <button class="formBtn" (click)="next.emit(config)">
          <span class="label"> {{ labels.stellar.submit }}</span>
        </button>
      </div>
    </section>
  </div>
</div>
